import Service from "../service";
const url = 'pregnant/form2'
const Pregnant2 ={
    saveForm(data){
        return Service.post(url,data);
    },
    show(id){
        return Service.get(`${url}`,{
            params:{
                form_id:id
            }
        });
    },
}
export default Pregnant2